import * as React from 'react';
import { getDynamicRoot } from '../utils/helpers';

export default function useDynamicRoot() {
  const rootRef = React.useRef<HTMLElement | null>(getDynamicRoot());

  return rootRef.current;
}
